import './Index.scss';
import { AppHeader } from '@ui/header';
import { CreateInitiativeNotifications } from './initiatives/notifications';
import { CreateTaskNotification } from '@initiatives/detail/tasks';
import { DashboardView } from './dashboard/DashboardView';
import { DataDictionaryView } from './data-dictionary/DataDictionaryView';
import { DataSecurityView } from './data-security/DataSecurityView';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FeatureRouteWrapper } from '@ui/features';
import { InitiativesIndex } from './initiatives/Index';
import { IssuesView } from './issues';
import { Layout } from 'antd';
import { ManageTagsView } from './tags';
import { PeriscopeInitiativeNotifications } from '@periscopes/notifications';
import React from 'react';
import { SalesforceReauthenticationNotification } from '@ui/notifications';
import { ScrollShadow } from '@ui/general';
import { SettingsIndex } from './settings/Index';
import { TimelineView } from '@timeline';
import { BASE_ROUTES, FULL_ROUTES, ROUTE_GROUPS } from '@sonar-software/sonar-ts-constants';
import { BulkOwnerNotification, BulkStakeholdersNotification, BulkTagNotification } from '@ui/notifications/bulk';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PeriscopeAnalysisModal, PeriscopeView } from './periscopes';
function getRootRoute(baseRoute) {
    return `/${baseRoute}/*`;
}
export const AppIndex = () => React.createElement(ScrollShadow, { scroller: '.app-content', shadow: '.app-header' },
    React.createElement(Layout, { hasSider: false, id: 'app' },
        React.createElement(AppHeader, null),
        React.createElement(Layout.Content, { className: 'app-content' },
            React.createElement(Routes, null,
                React.createElement(Route, { element: React.createElement(IssuesView, null), path: getRootRoute(BASE_ROUTES.ISSUES) }),
                React.createElement(Route, { element: React.createElement(DataSecurityView, null), path: getRootRoute(BASE_ROUTES.DATA_SECURITY) }),
                React.createElement(Route, { element: React.createElement(SettingsIndex, null), path: getRootRoute(BASE_ROUTES.SETTINGS) }),
                React.createElement(Route, { element: React.createElement(ManageTagsView, null), path: getRootRoute(BASE_ROUTES.TAGS) }),
                React.createElement(Route, { element: React.createElement(TimelineView, null), path: getRootRoute(BASE_ROUTES.TIMELINE) }),
                React.createElement(Route, { element: React.createElement(InitiativesIndex, null), path: getRootRoute(BASE_ROUTES.INITIATIVES) }),
                React.createElement(Route, { element: React.createElement(FeatureRouteWrapper, { feature: FeatureFlag.DataDictionary },
                        React.createElement(DataDictionaryView, null)), path: getRootRoute(BASE_ROUTES.DATA_DICTIONARY) }),
                React.createElement(Route, { element: React.createElement(PeriscopeView, null), path: getRootRoute(BASE_ROUTES.PERISCOPE) }),
                ROUTE_GROUPS.DASHBOARD.map((path) => React.createElement(Route, { element: React.createElement(DashboardView, null), key: path, path: getRootRoute(path) })),
                React.createElement(Route, { element: React.createElement(Navigate, { to: FULL_ROUTES.DASHBOARD }), path: '*' }))),
        React.createElement(PeriscopeAnalysisModal, null),
        React.createElement(CreateInitiativeNotifications, null),
        React.createElement(CreateTaskNotification, null),
        React.createElement(PeriscopeInitiativeNotifications, null),
        React.createElement(BulkOwnerNotification, { autoReset: true }),
        React.createElement(BulkStakeholdersNotification, { autoReset: true }),
        React.createElement(BulkTagNotification, { autoReset: true }),
        React.createElement(SalesforceReauthenticationNotification, null)));
